<div class="center">
<form [formGroup]="subscriptionConstructFormGroup" class="bulk-form">
    <div class="bulk-form-row" *ngIf="hasCashbackPermission">
        <label>Subscription Type:</label>
        <ng-select class="font-20" formControlName="selectedType" name="subscriptionType" placeholder="Select type">
            <ng-option *ngFor="let type of subscriptionTypes" [value]="type">{{type === 'REGULAR' ? 'PREPAID' : type}}</ng-option>
        </ng-select>
    </div>
    <div class="bulk-form-row" *ngIf="!isCashback">
        <label>State:</label>
        <ng-select class="font-20" formControlName="selectedState" name="state" placeholder="Select state">
            <ng-option *ngFor="let item of states" [value]="item">{{item.name}}</ng-option>
        </ng-select>
    </div>
    <div class="bulk-form-row" *ngIf="!isCashback">
        <label>City:</label>
        <ng-select class="font-20" formControlName="selectedCity" name="city" placeholder="Select city"
            [disabled]="!formValue('selectedState')">
            <ng-option *ngFor="let item of cities" [value]="item">{{item.name}}</ng-option>
        </ng-select>
    </div>
    <div class="bulk-form-row" *ngIf="!isCashback">
        <label>Mode:</label>
        <ng-select class="font-20" formControlName="selectedMode" name="mode" placeholder="Select mode"
            [disabled]="!formValue('selectedCity')">
            <ng-option *ngFor="let item of modes" [value]="item">{{item.name}}</ng-option>
        </ng-select>
    </div>
    <div class="bulk-form-row" *ngIf="!isCashback">
        <label>Category:</label>
        <ng-select class="font-20" formControlName="selectedCategory" name="category" placeholder="Select category"
            [disabled]="!formValue('selectedMode')">
            <ng-option *ngFor="let item of categories" [value]="item">{{item.name}}</ng-option>
        </ng-select>
    </div>
    <div class="bulk-form-row" *ngIf="!isCashback">
        <label>Service:</label>
        <ng-select class="font-20" formControlName="selectedService" name="service" placeholder="Select service"
            [disabled]="!formValue('selectedCategory')">
            <ng-option *ngFor="let item of services" [value]="item">{{item.name}}{{item.active === false ? ' (inactive)' : ''}}</ng-option>
        </ng-select>
    </div>
    <div class="bulk-form-row" *ngIf="!isCashback && formValue('selectedService')">
        <label></label>
        <span class="field-info">{{ taxInfoText }}</span>
    </div>
    <div class="bulk-form-row">
        <label>Start Date:</label>
        <p-calendar class="font-20" formControlName="fromDate" icon="pi pi-calendar" name="fromDate"
            [showIcon]=true dateFormat="d/m/yy" (ngModelChange)="changeInDate()" [minDate]="todayDate"
            [maxDate]="maxDate" [selectOtherMonths]="true" showTime="true" hourFormat="24" [stepMinute]="30">
        </p-calendar>
    </div>
    <div class="bulk-form-row">
        <label>End Date:</label>
        <p-calendar class="font-20" formControlName="toDate" icon="pi pi-calendar" name="toDate"
            [showIcon]=true dateFormat="d/m/yy" (ngModelChange)="changeInDate()" [minDate]="minDate"
            [selectOtherMonths]="true" showTime="true" hourFormat="24" [stepMinute]="30">
        </p-calendar>
    </div>
</form>
</div>
<mat-card class="margin-y-10">
  <span class="bold sample-file-title">Sample File Format</span>
  <div class="sample-file-table-wrapper">
      <table class="table table-striped table-bordered outerTable">
          <thead>
              <tr>
                  <th *ngFor="let header of sampleFileHeaders">{{header}}</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td *ngFor="let cell of sampleFileRow" class="displayStyle">{{cell}}</td>
              </tr>
          </tbody>
      </table>
  </div>
</mat-card>
<p-fileUpload #constructUpload accept="text/csv" [maxFileSize]="1000000" [showCancelButton]="false"
    [showUploadButton]="false" (onSelect)="handleFile($event)" class="margin-y-10"
    [disabled]="!canConstructBeUploaded()" (onRemove)="resetFile()" chooseLabel="Upload Construct File">
    <ng-template pTemplate="toolbar">
        <button pButton (click)="downloadSampleFile()" class="ui-button-secondary"
            style="background-color: gray; color: white;" label="Download Sample File">
        </button>
    </ng-template>
    <ng-template pTemplate="content">
    <div>
        <button mat-raised-button class="btn-primary" (click)="submitConstructs()"
            [disabled]="!fileDetails">
            Submit
        </button>
    </div>
    </ng-template>
</p-fileUpload>
<app-toaster [config]="toasterService.toaster"></app-toaster>
<app-authz-access-hint-footer [authzAccessHint]="authzAccessHint"></app-authz-access-hint-footer>

<ng-template #OverlappingPriorityRuleAlert>
  <h3 matDialogTitle>Subscription rule with same priority</h3>
  <table class="table table-striped table-bordered outerTable">
    <thead>
      <tr>
        <th>Rule Id</th>
        <th>Rule name</th>
        <th>Priority</th>
        <th>Amount</th>
        <th>Start Time</th>
        <th>End Time</th>
        <th>Period In Days</th>
        <th>Comission Type</th>
        <th>Validity Type</th>
        <th>Max Value</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rule of overlappingRules">
        <td class="displayStyle">{{rule.id}}</td>
        <td class="displayStyle">{{rule.ruleName}}</td>
        <td class="displayStyle">{{rule.priority}}</td>
        <td class="displayStyle">{{rule.ruleAmount}}</td>
        <td class="displayStyle">{{Utils.dateFromEpoch(rule.startTime*1000)}}</td>
        <td class="displayStyle">{{Utils.dateFromEpoch(rule.endTime*1000)}}</td>
        <td class="displayStyle">{{rule.periodInDays}}</td>
        <td class="displayStyle">{{rule.ruleType}}</td>
        <td class="displayStyle">{{rule.validity && rule.validity.length > 0 ? rule.validity[0].type : "unlimited"}}</td>
        <td class="displayStyle">{{rule.validity && rule.validity.length > 0 ? rule.validity[0].maxValue : null}}</td>
      </tr>
    </tbody>
  </table>
  <span>Please create a Subscription Rule with other priority to proceed</span>
  <div mat-dialog-actions class="button-flex" style="float:right;">
    <button mat-button matDialogClose>ok</button>
  </div>
</ng-template>
